import { render, staticRenderFns } from "./deliverGoodsNumber.vue?vue&type=template&id=0d48671f"
import script from "./deliverGoodsNumber.vue?vue&type=script&lang=js"
export * from "./deliverGoodsNumber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports